import { render, staticRenderFns } from "./TortaData.vue?vue&type=template&id=241e7c74&scoped=true&"
import script from "./TortaData.vue?vue&type=script&lang=js&"
export * from "./TortaData.vue?vue&type=script&lang=js&"
import style0 from "./TortaData.vue?vue&type=style&index=0&id=241e7c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e7c74",
  null
  
)

export default component.exports